export class TwitterAPIConfig {
    consumerKey:string;
    consumerSecretKey:string;

    constructor(json:any) {
        if(json!=null) {
            this.consumerKey = json.consumerKey;
            this.consumerSecretKey = json.consumerSecretKey;
        }
    }
}
